import AbstractGuestlistDetailsPageController from './abstract-details-controller';

export default class GuestlistOverviewPageController extends AbstractGuestlistDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/overview-controller.js